import { TagTypes } from '../../../Api/Types/tagTypes';
import {
  ReservationPaymentDto,
  RecordPaymentRequest,
  RecordRefundRequest,
  RecordPaymentResponse,
} from '../Types/reservationPaymentTypes';
import { reservationsApi } from './reservationsApi';

const reservationPaymentsApi = reservationsApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /api/admin/reservations/{id}/payments
    getReservationPayments: builder.query<ReservationPaymentDto[], number>({
      query: (reservationId) => `/reservations/${reservationId}/payments`,
      providesTags: (result, error, reservationId) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: TagTypes.ReservationPayment as const, id })),
              { type: TagTypes.ReservationPayment, id: TagTypes.List },
              { type: TagTypes.ReservationPayment, id: `LIST_${reservationId}` },
            ]
          : [
              { type: TagTypes.ReservationPayment, id: TagTypes.List },
              { type: TagTypes.ReservationPayment, id: `LIST_${reservationId}` },
            ],
    }),

    // POST /api/admin/reservations/{id}/payments
    recordPayment: builder.mutation<
      RecordPaymentResponse,
      { reservationId: number; data: RecordPaymentRequest }
    >({
      query: ({ reservationId, data }) => ({
        url: `/reservations/${reservationId}/payments`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { reservationId }) => [
        { type: TagTypes.ReservationPayment, id: `LIST_${reservationId}` },
        { type: TagTypes.Reservation, id: reservationId },
        { type: TagTypes.CashDocument, id: TagTypes.List }, // Refresh cash documents (auto-KP)
      ],
    }),

    // POST /api/admin/reservations/{id}/refunds
    recordRefund: builder.mutation<
      RecordPaymentResponse,
      { reservationId: number; data: RecordRefundRequest }
    >({
      query: ({ reservationId, data }) => ({
        url: `/reservations/${reservationId}/refunds`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { reservationId }) => [
        { type: TagTypes.ReservationPayment, id: `LIST_${reservationId}` },
        { type: TagTypes.Reservation, id: reservationId },
        { type: TagTypes.CashDocument, id: TagTypes.List }, // Refresh cash documents (auto-KW)
      ],
    }),
  }),
});

export const { useGetReservationPaymentsQuery, useRecordPaymentMutation, useRecordRefundMutation } =
  reservationPaymentsApi;

export default reservationPaymentsApi;
